The current status of the replay.

Currently, the following status codes are defined:

- `Submitted`
- `Running`
- `Completed`
- `Cancelled`
